import { EnumLanguage } from '@libs/constants';

import { IPodDesign } from '../contracts/pod-design.interface';
import { IGlobalText, IPodListingGlobal } from '../contracts/pod-listing.interface';
import { EnumGlobalColorOption, EnumGlobalTypeOption } from '../contracts/print-on-demand.constants';


/**------------------------------------------------------
 * Export Global data in the old XML-Format
 */
export class GlobalExportService {

	//** Exporting the global data as xml */
	getXmlFormattedData(data: IPodDesign): IGlobalXmlData {

		//0 - get the global listing data
		const globalData: IPodListingGlobal | null = data.listing?.global;

		//1 - format the global data into the old xml standard
		const formattedData: IGlobalXmlData = {
			title : {
				title_en 		: this.getText(globalData, EnumLanguage.EN)?.title || '',
				title_de 		: this.getText(globalData, EnumLanguage.DE)?.title || '',
				title_fr 		: this.getText(globalData, EnumLanguage.FR)?.title || '',
				title_it 		: this.getText(globalData, EnumLanguage.IT)?.title || '',
				title_es 		: this.getText(globalData, EnumLanguage.ES)?.title || ''
			},
			description : {
				description_en 	: this.getText(globalData, EnumLanguage.EN)?.description || '',
				description_de 	: this.getText(globalData, EnumLanguage.DE)?.description || '',
				description_fr 	: this.getText(globalData, EnumLanguage.FR)?.description || '',
				description_it 	: this.getText(globalData, EnumLanguage.IT)?.description || '',
				description_es 	: this.getText(globalData, EnumLanguage.ES)?.description || ''
			},
			tags : {
				tags_en 		: this.getText(globalData, EnumLanguage.EN)?.keywords.join(', ').trim() || '',
				tags_de 		: this.getText(globalData, EnumLanguage.DE)?.keywords.join(', ').trim() || '',
				tags_fr 		: this.getText(globalData, EnumLanguage.FR)?.keywords.join(', ').trim() || '',
				tags_it 		: this.getText(globalData, EnumLanguage.IT)?.keywords.join(', ').trim() || '',
				tags_es 		: this.getText(globalData, EnumLanguage.ES)?.keywords.join(', ').trim() || ''
			},
			options : {
				color 	: {
					option 		: ['black', 'white', 'colorful'],
					color_value : globalData?.options.templateMapping.color || EnumGlobalColorOption.Black
				},
				type	: {
					type_man	: globalData?.options.templateMapping.types.includes(EnumGlobalTypeOption.Men)   || false,
					type_woman	: globalData?.options.templateMapping.types.includes(EnumGlobalTypeOption.Women) || false,
					type_youth	: globalData?.options.templateMapping.types.includes(EnumGlobalTypeOption.Youth) || false
				}
			}
		};

		return formattedData;
	}


	/**------------------------------------------------------
	 * Helper Function
	 */
	private getText(globalData: IPodListingGlobal | null, lang: EnumLanguage): IGlobalText | null {

		//0 - try to get the text
		const globalText = globalData?.texts.find((text: IGlobalText) => text.language === lang);
		if (!globalText) return null;

		//1 - return the found text
		return globalText;
	}
}


//** Interfaces --------------------------------- */
export interface IGlobalXmlData {
	title : {
		title_en 		: string;
		title_de 		: string;
		title_fr 		: string;
		title_it 		: string;
		title_es 		: string;
	};
	description : {
		description_en 	: string;
		description_de 	: string;
		description_fr 	: string;
		description_it 	: string;
		description_es 	: string;
	};
	tags : {
		tags_en 		: string;
		tags_de 		: string;
		tags_fr 		: string;
		tags_it 		: string;
		tags_es 		: string;
	};
	options : {
		color 	: {
			option 		: string[];
			color_value : string;
		};
		type	: {
			type_man	: boolean;
			type_woman	: boolean;
			type_youth	: boolean;
		};
	};
}
